import React from 'react';
import { ScaleLinear } from 'd3-scale';
import { useDrawingArea, useXScale } from '@mui/x-charts/hooks';

import { useCurrentDebrief } from 'ff/debrief/hooks';
import { FFTheme } from 'ff/common/theme/StyledComponentThemes';

// Individual segment marker bar
export const SegmentMarker = (
    props: React.PropsWithChildren<{
        selected?: boolean;
        isOnlySelected?: boolean;
        start: number;
        end: number;
        label: string;
        color: string;
        leftPad?: boolean;
        rightPad?: boolean;
    }>
) => {
    const { isScoreModeEnabled } = useCurrentDebrief();
    const drawingArea = useDrawingArea();
    const xScale = useXScale() as ScaleLinear<number, number>;

    const borderRadius = 1.5;
    const padding = 1;
    const verticalOffset = 6;

    const zoneTop = props.selected
        ? drawingArea.top + drawingArea.height + verticalOffset
        : drawingArea.top + drawingArea.height + verticalOffset + 6;
    const zoneRight = props.rightPad
        ? xScale(props.end) - padding
        : xScale(props.end);
    const zoneBottom =
        drawingArea.top + drawingArea.height + verticalOffset + 12;
    const zoneLeft = props.leftPad
        ? xScale(props.start) + padding
        : xScale(props.start);

    const pathStart = {
        x: props.leftPad ? zoneLeft + borderRadius : zoneLeft,
        y: zoneTop,
    };

    const zoneWidth = Math.abs(zoneLeft - zoneRight);
    const zoneHeight = Math.abs(zoneTop - zoneBottom);
    let topLineWidth: number;
    if (!props.leftPad && !props.rightPad) {
        topLineWidth = zoneWidth;
    } else if (
        (props.leftPad && !props.rightPad) ||
        (!props.leftPad && props.rightPad)
    ) {
        topLineWidth = zoneWidth - borderRadius;
    } else {
        topLineWidth = zoneWidth - 2 * borderRadius;
    }
    const bottomLineWith = topLineWidth * -1;
    const leftLineHeight =
        (props.leftPad ? zoneHeight - 2 * borderRadius : zoneHeight) * -1;
    const rightLineHeight = props.rightPad
        ? zoneHeight - 2 * borderRadius
        : zoneHeight;

    const topLeftCurve = props.leftPad
        ? `q0,-${borderRadius} ${borderRadius},-${borderRadius}`
        : '';
    const topRightCurve = props.rightPad
        ? `q${borderRadius},0 ${borderRadius},${borderRadius}`
        : ``;
    const bottomRightCurve = props.rightPad
        ? `q 0,${borderRadius} -${borderRadius},${borderRadius}`
        : ``;
    const bottomLeftCurve = props.leftPad
        ? `q -${borderRadius},0 -${borderRadius},-${borderRadius}`
        : ``;

    const color = isScoreModeEnabled
        ? props.color
        : props.color !== '#21C1FA'
          ? FFTheme.blue
          : props.color;

    return (
        <>
            <path
                d={`M${pathStart.x},${pathStart.y} h${topLineWidth} ${topRightCurve} v${rightLineHeight} ${bottomRightCurve} h${bottomLineWith} ${bottomLeftCurve} v${leftLineHeight} ${topLeftCurve}`}
                fill={color}
            />
        </>
    );
};

export default SegmentMarker;
